import React, { useEffect, useState } from 'react';
import { StyledButton } from './styles';
import { Modal, Button as BootstrapButton } from 'react-bootstrap';
import { LuCalendarClock } from 'react-icons/lu';
import { VincularAgendamentoProps } from './types';
import { toast } from 'react-toastify';
import { GridAgendamento } from './components/GridAgendamento';
import { AgendamentoSelecionadosStorage } from './class/AgendamentoSelecionadosStorage';
import { formataArrayDefault } from './utils/formataArrayDefault';
import { Tooltip } from '@material-ui/core';

export const VincularAgendamento: React.FC<VincularAgendamentoProps> = ({
  codTela,
  codPessoa,
  codLoja,
  qtdAgendamento,
  onSuccess,
  tipoOperacao = undefined, // 0 - Entrada; 1 - Saída
}) => {
  const [show, setShow] = useState(false);
  const [qtd, setQtd] = useState(0);

  useEffect(() => {
    const { pagar, receber } = qtdAgendamento;

    if (!tipoOperacao) setQtd(pagar + receber);
    else if (tipoOperacao === 0) setQtd(pagar);
    else setQtd(receber);
  }, [qtdAgendamento, tipoOperacao, codPessoa]);

  const handleClose = () => {
    const selecionados = AgendamentoSelecionadosStorage.get(codTela);

    if (onSuccess) onSuccess(formataArrayDefault(selecionados));
    setShow(false);
  };

  const handleOpen = () => {
    if (!codPessoa || codPessoa <= 0) {
      setShow(false);
      toast.warning('Antes de continuar, é necessário informar um parceiro');
      return;
    }

    if (
      (tipoOperacao && tipoOperacao > 1) ||
      typeof tipoOperacao === 'undefined'
    ) {
      setShow(false);
      toast.warning('Antes de continuar, é necessário informar um perfil');
      return;
    }

    setShow(true);
  };

  const labelAgendamento = qtd > 1 ? 'Agendamentos' : 'Agendamento';

  return (
    <>
      <Tooltip
        title={`Pagar: ${qtdAgendamento.pagar}; Receber: ${qtdAgendamento.receber}`}
        arrow
      >
        <StyledButton
          onClick={handleOpen}
          type="button"
          disabled={
            !codPessoa ||
            codPessoa <= 0 ||
            (qtdAgendamento.pagar === 0 && qtdAgendamento.receber === 0)
          }
          id={`vincula-agendamento-${codTela}`}
        >
          <LuCalendarClock size={22} color="red" /> {labelAgendamento} ({qtd})
        </StyledButton>
      </Tooltip>

      <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
        <Modal.Header>
          <Modal.Title>Associar agendamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GridAgendamento
            codPessoa={codPessoa}
            codLoja={codLoja}
            modalOpen={show}
            codTela={codTela}
            tipoOperacao={tipoOperacao}
          />
        </Modal.Body>
        <Modal.Footer>
          <BootstrapButton
            style={{ backgroundColor: '#009E0F', border: 'none' }}
            onClick={handleClose}
            type="button"
          >
            Concluir
          </BootstrapButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};
